var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TokenClient } from '../services/authentication/token-client.service';
import * as Enumerable from 'linq';
import { autoinject, transient } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { FormatterHelper } from '../helpers/numbers-helper';
import { CurrencyCodeEnum } from '../models/modules/lotteryplatofrm.models';
var numeral = require('numeral');
// FONB lotteries advertise a fixed prize that should be shown in full (e.g. €50,000),
// never abbreviated like rolling jackpots (€50k / €50Thousand). Shared by both jackpot converters.
function formatFonbFullNumber(valueInUserCurrency, currencySymbol, showSymbol) {
    numeral.locale('en');
    var formatted = numeral(valueInUserCurrency ? valueInUserCurrency : 0).format('0,0');
    return showSymbol ? formatted : currencySymbol + formatted;
}
var CurrencyJackpotValueConverter = /** @class */ (function () {
    function CurrencyJackpotValueConverter(tokenClient, i18n) {
        this.tokenClient = tokenClient;
        this.i18n = i18n;
    }
    CurrencyJackpotValueConverter.prototype.getTicketSalesClosing = function (lottery) {
        var dbDate = lottery.drawDate ? new Date(lottery.drawDate) : new Date();
        var dbTime = new Date(lottery.ticketSalesClosingTime);
        dbDate.setHours(dbTime.getHours());
        dbDate.setMinutes(dbTime.getMinutes());
        dbDate.setSeconds(dbTime.getSeconds());
        return dbDate;
    };
    CurrencyJackpotValueConverter.prototype.toView = function (lottery, showSymbol, showTBA) {
        if (showTBA === void 0) { showTBA = true; }
        if (!lottery || !lottery.totalJackpot) {
            return this.i18n.tr('TBA');
        }
        //is draw date calculate or ticketSalesClosingTime < than current Time
        if (showTBA && (lottery.isDrawDateCalculated || new Date() > this.getTicketSalesClosing(lottery))) {
            return this.i18n.tr('TBA');
        }
        var userCurrency = this.tokenClient.getUserCurrency();
        var isUserCurrencyInIndianFormat = userCurrency.currencyCode.toUpperCase() == CurrencyCodeEnum.Inr.toUpperCase();
        var currencies = this.tokenClient.currencies;
        var lotteryCurrencyId = lottery.currencyId;
        // if(lotteryCurrencyId == 0){
        //     console.log('currency not found');
        // }
        var lotteryJackpot = lottery.totalJackpot;
        var lotteryCurrency = Enumerable.from(currencies).firstOrDefault(function (x) { return x.currencyId == lotteryCurrencyId; });
        var lotteryCurrencyRate = lotteryCurrency.currencyRates ? lotteryCurrency.currencyRates[0] : null;
        var euroRate = lotteryCurrencyRate ? lotteryCurrencyRate.euroRate : 1;
        var euroConversionRate = (1 / euroRate);
        //1 of the lottery currency is equals to euroConversionRate
        var lotteryjackpotInEur = (lotteryJackpot * euroConversionRate);
        var lotteryJackpotInUserCurrency = 0;
        //not euro we need to calculate - if euro the eurorate is one so it is the same
        var userCurrencyRate = userCurrency.currencyRates ? userCurrency.currencyRates[0] : null;
        var userCurrencyEuroRate = userCurrencyRate ? userCurrencyRate.euroRate : 1;
        lotteryJackpotInUserCurrency = (lotteryjackpotInEur * userCurrencyEuroRate);
        if (lottery.isFonb) {
            return formatFonbFullNumber(lotteryJackpotInUserCurrency, userCurrency.symbol, showSymbol);
        }
        var numeralResult;
        if (isUserCurrencyInIndianFormat) {
            numeralResult = (new IndianCurrencyFormatter).formatToINRCurrency(lotteryJackpotInUserCurrency, true, 2);
        }
        else {
            numeralResult = this.convertString(lotteryJackpotInUserCurrency, null, lottery.isCustom);
        }
        var result = showSymbol ? numeralResult : userCurrency.symbol + numeralResult;
        return result;
    };
    CurrencyJackpotValueConverter.prototype.convertString = function (value, currencySymbol, isCustom) {
        numeral.locale('en');
        //        var decimalPlaces = value >= 1000000000 ? "0.00a" : isCustom ? "0.0a" : "0a"; removed since Ade wanted the custom lotteries to not have decimal places 
        var decimalPlaces = value >= 1000000000 ? "0.00a" : isCustom ? "0a" : "0a";
        var format = '(' + currencySymbol + decimalPlaces + ')';
        var convertedNumeral = numeral(value ? value : 0).format(format);
        return convertedNumeral;
    };
    CurrencyJackpotValueConverter = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient, I18N])
    ], CurrencyJackpotValueConverter);
    return CurrencyJackpotValueConverter;
}());
export { CurrencyJackpotValueConverter };
var CartCurrencyValueConverter = /** @class */ (function () {
    function CartCurrencyValueConverter(tokenClient) {
        this.tokenClient = tokenClient;
    }
    CartCurrencyValueConverter.prototype.toView = function (item, showSymbol, asNumber) {
        if (!item) {
            return "";
        }
        var userCurrency = this.tokenClient.getUserCurrency();
        var price = item.totalPrice;
        var formatted = FormatterHelper.getformattedValue(Number(price), navigator.language, 2);
        return showSymbol ? userCurrency.symbol + formatted : formatted;
    };
    CartCurrencyValueConverter = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient])
    ], CartCurrencyValueConverter);
    return CartCurrencyValueConverter;
}());
export { CartCurrencyValueConverter };
var CurrencyJackpotFullValueConverter = /** @class */ (function () {
    function CurrencyJackpotFullValueConverter(tokenClient, i18n) {
        this.tokenClient = tokenClient;
        this.i18n = i18n;
        numeral.register('locale', 'custom', {
            abbreviations: {
                thousand: 'Thousand',
                million: 'Million',
                billion: 'Billion',
                trillion: 'Trillion'
            },
            delimiters: {
                decimal: "."
            }
        });
    }
    CurrencyJackpotFullValueConverter.prototype.getTicketSalesClosing = function (lottery) {
        var dbDate = lottery.drawDate ? new Date(lottery.drawDate) : new Date();
        var dbTime = new Date(lottery.ticketSalesClosingTime);
        dbDate.setHours(dbTime.getHours());
        dbDate.setMinutes(dbTime.getMinutes());
        dbDate.setSeconds(dbTime.getSeconds());
        return dbDate;
    };
    CurrencyJackpotFullValueConverter.prototype.toView = function (lottery, showSymbol, showTBA, tbaText) {
        if (showTBA === void 0) { showTBA = true; }
        if (tbaText === void 0) { tbaText = null; }
        if (!lottery || !lottery.totalJackpot) {
            return tbaText ? tbaText : this.i18n.tr('TBA');
        }
        if (showTBA && (lottery.isDrawDateCalculated || new Date() > this.getTicketSalesClosing(lottery))) {
            return tbaText ? tbaText : this.i18n.tr('TBA');
        }
        var userCurrency = this.tokenClient.getUserCurrency();
        var isUserCurrencyInIndianFormat = userCurrency.currencyCode.toUpperCase() == CurrencyCodeEnum.Inr.toUpperCase();
        var currencies = this.tokenClient.currencies;
        var lotteryCurrencyId = lottery.currencyId;
        // if(lotteryCurrencyId == 0){
        //     console.log('currency not found');
        // }
        var lotteryJackpot = lottery.totalJackpot;
        var lotteryCurrency = Enumerable.from(currencies).firstOrDefault(function (x) { return x.currencyId == lotteryCurrencyId; });
        var lotteryCurrencyRate = lotteryCurrency.currencyRates ? lotteryCurrency.currencyRates[0] : null;
        var euroRate = lotteryCurrencyRate ? lotteryCurrencyRate.euroRate : 1;
        var euroConversionRate = (1 / euroRate);
        //1 of the lottery currency is equals to euroConversionRate
        var lotteryjackpotInEur = (lotteryJackpot * euroConversionRate);
        var lotteryJackpotInUserCurrency = 0;
        //not euro we need to calculate - if euro the eurorate is one so it is the same
        var userCurrencyRate = userCurrency.currencyRates ? userCurrency.currencyRates[0] : null;
        var userCurrencyEuroRate = userCurrencyRate ? userCurrencyRate.euroRate : 1;
        lotteryJackpotInUserCurrency = (lotteryjackpotInEur * userCurrencyEuroRate);
        if (lottery.isFonb) {
            return formatFonbFullNumber(lotteryJackpotInUserCurrency, userCurrency.symbol, showSymbol);
        }
        var numeralResult;
        if (isUserCurrencyInIndianFormat) {
            numeralResult = (new IndianCurrencyFormatter).formatToINRCurrency(lotteryJackpotInUserCurrency, false, 2);
        }
        else {
            numeralResult = this.convertString(lotteryJackpotInUserCurrency, null, lottery.isCustom);
        }
        var result = showSymbol ? numeralResult : userCurrency.symbol + numeralResult;
        return result;
    };
    CurrencyJackpotFullValueConverter.prototype.convertString = function (value, currencySymbol, isCustom) {
        numeral.locale('custom');
        var decimalPlaces = value >= 1000000000 ? "0.00a" : isCustom ? "0.0a" : "0a";
        var format = '(' + currencySymbol + decimalPlaces + ')';
        var convertedNumeral = numeral(value ? value : 0).format(format);
        return convertedNumeral;
    };
    CurrencyJackpotFullValueConverter = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient, I18N])
    ], CurrencyJackpotFullValueConverter);
    return CurrencyJackpotFullValueConverter;
}());
export { CurrencyJackpotFullValueConverter };
var IndianCurrencyFormatter = /** @class */ (function () {
    function IndianCurrencyFormatter() {
        this.INR_CRORE = 10000000; // 1,00,00,000; for more info https://en.wikipedia.org/wiki/Crore
        this.INR_LAKH = 100000; // 1,00,000; for more info https://en.wikipedia.org/wiki/Lakh
        this.INR_THOUSAND = 1000; // 1,000
    }
    IndianCurrencyFormatter.prototype.formatToINRCurrency = function (amount, isShort, precision) {
        if (isShort === void 0) { isShort = true; }
        if (precision === void 0) { precision = 0; }
        amount = amount || 0;
        var absAmount = Math.abs(amount);
        var abbreviation = '';
        if (absAmount >= this.INR_CRORE) {
            amount = (amount / this.INR_CRORE);
            abbreviation += isShort ? "cr" : "Crores";
        }
        else if (absAmount >= this.INR_LAKH) {
            amount = (amount / this.INR_LAKH);
            abbreviation += isShort ? "L" : "Lakhs";
        }
        else if (absAmount >= this.INR_THOUSAND) {
            amount = (amount / this.INR_THOUSAND);
            abbreviation += isShort ? "k" : 'Thousand';
        }
        return amount.toFixed(precision) + abbreviation;
    };
    return IndianCurrencyFormatter;
}());
